import {useNavigate} from "react-router-dom"
import {CourseItem} from "../../../features/courses/api/course.api"
import {CourseCover} from "./CourseCover"

export const CoursesList = ({courses}: {courses: CourseItem[]}) => {
    const navigate = useNavigate()

    if (!courses.length) {
        return <div className="p-6 text-gray-500">No courses yet</div>
    }

    return (
        <div className="space-y-3 max-w-4xl">
            {courses.map((course) => (
                <div
                    key={course.id}
                        onClick={() => navigate(`/courses/${course.id}/chat`)}
                    className="
        cursor-pointer
        bg-white
        border
        rounded-2xl
        px-5 py-4
        flex items-center gap-4 justify-between
        transition
        hover:shadow-md
        hover:border-emerald-200
    "
                >
                    <CourseCover title={course.title} cover={course.cover_image} />

                    <div className="flex-1 min-w-0">
                        <div className="font-semibold truncate">{course.title}</div>
                        <div className="text-sm text-gray-500 truncate">
                            {course.description || "Course chat"}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
